export default "__VITE_ASSET__5a44db20__"